const LOGOS = [
  "Larrosa",
  "CBRE Local",
  "Comercia",
  "Locales&Co",
  "Negocios+",
  "Urban Retail",
];

export function TrustLogos() {
  return (
    <section className="border-y border-border bg-surface">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 py-10">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.22em] text-muted-foreground mb-6">
          Confían en Bizaclia
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 opacity-70">
          {LOGOS.map((logo) => (
            <span
              key={logo}
              className="font-display font-bold text-xl text-muted-foreground tracking-tight"
            >
              {logo}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
